import { generalConstants } from '../_constants';
import { generalService } from '../_services';

export const generalActions = {
    getMenus
};

//Test API fetch data from MenuController
function getMenus() {
    return  generalService.getMenus()
}

export const getColorList = (type) => ({
    type: generalConstants.GET_COLOR_LIST_START,
    payload: type
})
export const getColorListSuccess = (data) => ({
    type: generalConstants.GET_COLOR_LIST_SUCCESS,
    payload: data
})
export const getColorListFailure = (error) => ({
    type: generalConstants.GET_COLOR_LIST_FAILURE,
    payload: error
})
export const clearColorList = (type) => ({
    type: generalConstants.CLEAR_COLOR_LIST,
    payload: type
})
